import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=f13f6126&scoped=true&"
import script from "./qrcode.vue?vue&type=script&lang=js&"
export * from "./qrcode.vue?vue&type=script&lang=js&"
import style0 from "./qrcode.vue?vue&type=style&index=0&id=f13f6126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13f6126",
  null
  
)

export default component.exports